'use client';

import AnimatedLogoText from "@/components/AnimatedLogoText";
import ThemeToggle from "@/components/ThemeToggle";
import { Link } from "@heroui/react";
import Image from "next/image";
import { Button } from "@/components/ui/Button";
import { FaUserPlus } from "react-icons/fa";
import { getNativeLanguageByCode } from "@/lib/constants";
import { usePathname } from "next/navigation";
import LoginModal from "./LoginModal";
import { useState } from "react";
import { PLAUSIBLE_EVENTS, trackPlausibleEvent } from "@/lib/client-stats";

export default function Header() {
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const closeLogin = () => setIsLoginOpen(false);

    // Parse the URL    
    const pathname = usePathname();

    const pathnameParts = pathname.split('/');
    let nativeLanguageCode = "en-us";

    if (pathnameParts[1] == "learn" || pathnameParts[1] == "focus" || pathnameParts[1] == "phrasebook"  || pathnameParts[1] == "topics") {
        if (pathnameParts[3]) {
            nativeLanguageCode = pathnameParts[3];
        }
    }

    const nativeLanguage = getNativeLanguageByCode(nativeLanguageCode);
    
    // Detect native language from URL (we're in a server component)
    const t = getTranslations(nativeLanguage?.name || "english");

    const handleHeaderLoginClick = () => {
        setIsLoginOpen(true);
        trackPlausibleEvent({name: PLAUSIBLE_EVENTS.seoLoginPopupOpened, onlyOnce: true});
    };

    return (
        <header className="bg-white sm:bg-transparent border-b sm:border-none border-gray-200 dark:border-gray-700 sticky top-0 sm:static z-30 sm:max-w-3xl sm:mx-auto">
            <div className="flex justify-between items-center h-12 sm:h-16 px-2 sm:px-6 ">
                <div className="flex items-center gap-2">
                    <Link href="/"><Image src="/images/logo-web-lush-sm.png" alt="Chatlanga Logo" width={44} height={44} priority={false} /></Link>
                    <AnimatedLogoText displaySubtext={false} />
                </div>
                
                <div className="flex items-center gap-4">            
                    {/* <ThemeToggle /> */}
                    {/* Join button */}
                    <Button size="sm" radius="full" color="lushSecondary" onClick={handleHeaderLoginClick} className="flex items-center gap-2">
                        <FaUserPlus className="w-4 h-4 sm:visible" />
                        {t.join}
                    </Button>
                </div>
            </div>

            <LoginModal isOpen={isLoginOpen} onClose={closeLogin} locale={nativeLanguage?.name || 'english'} />
        </header>
    );
}

function getTranslations(nativeLanguage: string): any {    
    if (nativeLanguage === "english") { 
        return {
            join: "Join",
        };
    } else if (nativeLanguage === "russian") {
        return {
            join: "Войти",
        };
    } else if (nativeLanguage === "spanish") {
        return {
            join: "Entrar",
        };
    } else {
        return {
            join: "Join",
        };
    }
}